import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { FeatureToggle } from './featureToggles'
import { Permission } from './permissions'

export const modifyFulfillmentRuleAccessControl: DomainAccessControlConfig = [
  {
    featureToggles: [FeatureToggle.deliveryOrchestration],
    permissions: [Permission.Modify],
    restrictedBannersAllowed: true,
  },
  {
    warehouseFeatureToggles: [FeatureToggle.deliveryOrchestration],
    permissions: [Permission.Modify],
    restrictedBannersAllowed: true,
  },
]
